module.exports = __webpack_public_path__ + "static/media/icon_inhaler.e7d632a2.svg";